import { Text } from '@/components/atoms/Text';

export const EmptyRichResponse = ({ message }: { message: string }) => {
  return (
    <Text
      variant='body-m'
      classNames={{
        wrapper:
          'font-[monospace] text-center px-2 py-4 w-full h-full flex items-center justify-center text-gray-dark-500',
      }}
    >
      {message}
    </Text>
  );
};
